import { isAdmin, isRoot } from './utils';

/**
 * Console rail links — keep in sync with Home landing console rail.
 * @param {(key: string) => string} t i18n translate
 * @param {boolean} hasUser whether a session user exists
 */
export function buildConsoleRailLinks(t, hasUser) {
  const docAbout = [
    { key: 'docs', label: 'Docs', to: '/docs' },
    { key: 'about', label: 'About', to: '/about' },
  ];
  if (!hasUser) {
    return [
      { key: 'plans', label: t('header.plans'), to: '/plans' },
      ...docAbout,
    ];
  }
  const links = [];
  if (isAdmin()) {
    links.push({ key: 'channel', label: 'Channels', to: '/channel' });
  }
  links.push(
    { key: 'token', label: 'Tokens', to: '/token' },
    { key: 'model_rates', label: t('header.model_rates'), to: '/model-rates' },
    { key: 'plans', label: t('header.plans'), to: '/plans' },
    { key: 'topup', label: 'Top-up', to: '/topup' }
  );
  if (isAdmin()) {
    links.push(
      { key: 'redemption', label: 'Redeem', to: '/redemption' },
      { key: 'user', label: 'Users', to: '/user' }
    );
  }
  links.push(
    { key: 'dashboard', label: 'Overview', to: '/dashboard' },
    { key: 'log', label: 'Logs', to: '/log' }
  );
  if (isRoot()) {
    links.push({ key: 'setting', label: 'Settings', to: '/setting' });
  }
  links.push(...docAbout);
  return links;
}

/** Active when current path is exactly `to` or a nested route under it. */
export function isConsoleNavActive(pathname, to) {
  if (!to || to === '/') return false;
  if (pathname === to) return true;
  return pathname.startsWith(`${to}/`);
}
